import { getEnv } from '../../config/env';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { logger } from '../../utils/logger';
import { getV2AuthHeaders } from '../../utils/authHeaders';

/**
 * Toggles the isActive state of a recurring migration schedule
 * @param accessToken - Bearer token for authentication
 * @param migrationId - ID of the migration to toggle
 * @returns The updated migration object with isActive state
 */
export async function toggleMigrationActive(
  accessToken: string,
  migrationId: string
): Promise<{ isActive: boolean }> {
  const env = getEnv();
  const baseUrl = env.VITE_EDCI_API_URL.replace(/\/$/, '');
  const url = `${baseUrl}/api/migrations/${migrationId}/toggle-active`;

  logger.info('Toggling migration active state', { migrationId });

  try {
    const response = await authenticatedFetch(url, {
      method: 'PATCH',
      headers: {
        ...getV2AuthHeaders(accessToken),
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      logger.error('Failed to toggle migration active state', {
        migrationId,
        status: response.status,
        statusText: response.statusText
      });
      throw new Error(`Failed to toggle migration: ${response.statusText}`);
    }

    const data = await response.json();
    logger.info('Migration active state toggled successfully', {
      migrationId,
      isActive: data.isActive
    });
    return data;
  } catch (error) {
    logger.error('Error toggling migration active state', { migrationId, error });
    throw error;
  }
}

export default toggleMigrationActive;
